import React from "react";
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setStep, setInfo, setFinance, setLatest, setCurrent } from "../../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing BankSelector for autocomplete Banks input box
*/
import BankSelector from "../../partials/BankSelector";

/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextFinanceButton from "../../partials/NextFinanceButton";
/*
    This page is using a template VerifyLayout
    TODO: May change this to one StepLayout
*/
import AccountLayout from '../../../containers/AccountLayout';
import '../StartApplication/Welcome.css';

import banks from "./banks.json";
/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();

/*
    EmploymentInfo view that displays the Employment Info page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/

class BankingInfo extends React.Component {

  constructor(){
    super();

    this.routingchecked = false;
    this.accountchecked = false;
    this.accounttypechecked = false;
    this.myacctTO = "";
    this.myrouteTO = "";
    this.myroutingTO = "";

    this.handleRoutingChange = this.handleRoutingChange.bind(this);
    this.handleRoutingBlur = this.handleRoutingBlur.bind(this);
    this.handleAccountTypeChange = this.handleAccountTypeChange.bind(this);
    this.handleAccountChange = this.handleAccountChange.bind(this);
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Banking Information");
    this.props.lateststep < 7 && this.props.setLatest(7);
    this.props.setCurrent(7);
    this.props.setStep(1);
    this.props.setInfo(3);
    this.props.setFinance(2);

    if (this.props.routingnum.length < 1){
      this.myrouteTO = setTimeout(()=>{
        document.getElementById('routing').focus();
        clearTimeout(this.myrouteTO);
      }, 100);
    } else if (this.props.routingnum.length === 9){
      this.routingchecked = true;
      document.getElementById("bankdetails").classList.remove("hidden");
      document.querySelector("label[for='routing']").classList.add("active");
      if (this.props.bank.length > 0){
        document.getElementById("accountdetails").classList.remove("hidden");
        document.querySelector("label[for='bank']").classList.add("active");
      }
      if (this.props.bankaccount.length >= 7){
        this.accountchecked = true;
        document.querySelector("label[for='acct']").classList.add("active");
      }
      if (this.props.accounttype.length > 0){
        let querydataanswer = "[data-answer='"+this.props.accounttype+"']";
        document.querySelectorAll(querydataanswer)[0].classList.add('activated');
        this.accounttypechecked = true;
      }
    }
  }

  handleRoutingChange(e) {
    let routing = e.target.value;
    let routingtip = document.getElementById("routingtip");

    routing = routing.replace(/\D/g, '');
    if (routing.length === 0){
      routingtip.classList.remove("hidden");
      routingtip.innerHTML = "Please enter numbers only.";
    } else {
      routingtip.classList.add("hidden");
      routingtip.innerHTML = "";
    }

    this.props.updateForm("routingnum", routing);

    let bankdetails = document.getElementById("bankdetails");

    this.routingchecked = false;
    this.props.updateForm("bankchecked", false);
    document.getElementById("accountdetails").classList.add("hidden");

    let accountdetails = document.getElementById("accountdetails");
    let routinglabel = document.querySelector("label[for='routing']");
    let banklabel = document.querySelector("label[for='bank']");

    if (routing.length === 8){
      let thebanks = [];
      let matchedbanks = [];
      // eslint-disable-next-line
      banks.map(function(bank) {
        // eslint-disable-next-line
        let last8 = bank.routing.substr(bank.routing.length - 8);
        let first8 = bank.routing.substr(0, 8);
        // eslint-disable-next-line
        if (bank.routing[0] == "0" && last8 == routing){
          thebanks.push(bank.name);
        }
        // eslint-disable-next-line
        if (first8 == routing){
          matchedbanks.push(bank.name);
        }
      });
      if (thebanks.length === 1 && matchedbanks.length === 0){

        this.props.updateForm("routingnum", "0"+routing);

        this.routingchecked = true;
        routingtip.classList.add("hidden");
        routingtip.innerHTML = "";
        bankdetails.classList.remove("hidden");

        this.props.updateForm("bankchecked", true);
        accountdetails.classList.remove("hidden");
        routinglabel.classList.add("active");
        banklabel.classList.add("active");
        this.props.updateForm("bank", thebanks[0]);

        this.myacctTO = setTimeout(()=>{document.getElementById("acct").focus()},10);

        if (window.pageYOffset < 250)
          scroll.scrollTo(250, {duration: 1000});

        this.props.updateForm("allbankingchecked", validation.checkAll([true,this.accounttypechecked,this.accountchecked]))
      } else {
        this.props.updateForm("bank", "");
        bankdetails.classList.add("hidden");
      }
    } else if (routing.length === 9){
      this.routingchecked = true;
      routingtip.classList.add("hidden");
      routingtip.innerHTML = "";

      bankdetails.classList.remove("hidden");

      let thebank = "";
      let _this = this;
      // eslint-disable-next-line
      banks.map(function(bank) {
        if (bank.routing === routing){
          thebank = bank.name;
          _this.props.updateForm("bankchecked", true);
          accountdetails.classList.remove("hidden");
          routinglabel.classList.add("active");
          banklabel.classList.add("active");
          document.getElementById("acct").focus();
          _this.props.updateForm("bank", thebank);
          if (window.pageYOffset < 250)
            scroll.scrollTo(250, {duration: 1000});
        }
      });
      if (thebank.length > 0){
        this.props.updateForm("allbankingchecked", validation.checkAll([true,this.accounttypechecked,this.accountchecked]))
      } else {
        // TODO if no bank found for that routing number - maybe show note to agent to update db if it is a valid missing routing number?
        banklabel.classList.remove("active");
        this.props.updateForm("bank", "");
        document.getElementById("bank").focus();
      }
    } else {
      bankdetails.classList.add("hidden");
      this.props.updateForm("allbankingchecked", false);
    }
  }

  handleRoutingBlur(e) {
    //mock async due to state of routingnum
    this.myroutingTO = setTimeout(()=>{
      let routing = this.props.routingnum;
      let routingtip = document.getElementById("routingtip");
      if (routing.length < 9){
        routingtip.classList.remove("hidden");
        if (routing.length < 1){
          routingtip.innerHTML = "Please enter a routing number.";
        } else {
          routingtip.innerHTML = "Please enter a 9 digit routing number.";
        }
      }
      clearTimeout(this.myroutingTO);
    }, 10);
  }

  handleAccountChange(e) {
    clearTimeout(this.myacctTO);
    let acct = e.target.value.replace(/\D/g, '');

    let accttip = document.getElementById("accttip");
    if (acct.length === 0){
      accttip.classList.remove("hidden");
      accttip.innerHTML = "Please enter numbers only.";
    } else {
      accttip.classList.add("hidden");
      accttip.innerHTML = "";
    }
    this.props.updateForm("bankaccount", acct);

    const acctlabel = document.querySelector("label[for='acct']");
    this.accountchecked = false;
    if (acct.length >= 7){
      accttip.classList.add("hidden");
      accttip.innerHTML = "";
      this.accountchecked = true;
      acctlabel.classList.add("active");
      this.props.updateForm("allbankingchecked", validation.checkAll([true,this.accounttypechecked,this.accountchecked,this.props.bankchecked,this.routingchecked]))
    } else {
      acctlabel.classList.remove("active");
      this.props.updateForm("allbankingchecked", false);
    }

  }
  handleAccountBlur(e) {
    let accttip = document.getElementById("accttip");

    if (e.target.value.length < 4){
      accttip.classList.remove("hidden");
      accttip.innerHTML = "Please enter your account number.";
    }
  }

  handleAccountTypeChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.typebtn'), function(el) {
      el.classList.remove("activated");
    });
    e.target.classList.add("activated");

    this.accounttypechecked = true;
    this.props.updateForm("accounttype", e.target.dataset.answer);

    this.props.updateForm("allbankingchecked", validation.checkAll([true,this.accountchecked,this.props.bankchecked,this.routingchecked]));

    if (window.pageYOffset < 350)
      scroll.scrollTo(350, {duration: 800});
  }

  render() {

    const nextFinance = 2;
    const nextLink = "/preapproved";
    const btnText = "Submit";
    const btnClasses = "btn next-step";

      return (
        <AccountLayout>
          <div className="container" id="stepper-step-3">
            <div className="text-center topcopy">
                <h1>Where do you bank?</h1>
            </div>

            <hr />
            <div className="text-center">
              <img src="/images/svg/check.svg" className="style-svg" alt="" />
            </div>
            <form className="flowform">
                <input type="hidden" value="needed for disabling autocomplete" />
                <div className="form-group padtop">
                    <label htmlFor="routing">Your Routing Number
                      <div className="errortip hidden" id="routingtip">
                          Please provide your routing number.
                      </div>
                      <input type="text" name="routing" id="routing" autoComplete="routing" className="form-control" value={this.props.routingnum} onChange={this.handleRoutingChange} onBlur={this.handleRoutingBlur} tabIndex="1" maxLength="9"/>
                    </label>
                </div>

              <div id="bankdetails" className="hidden">
                <div className="form-group">
                    <label htmlFor="bank">Your Bank
                      <div className="errortip hidden" id="banktip">
                          Please provide your bank.
                      </div>
                      <BankSelector />
                    </label>
                </div>
                <div id="accountdetails" className="form-group padtop hidden">
                    <label htmlFor="acct">Your Account Number
                      <div className="errortip hidden" id="accttip">
                          Please provide your Account Number.
                      </div>
                      <input type="text" name="acct" id="acct" autoComplete="acct" className="form-control" value={this.props.bankaccount} onChange={this.handleAccountChange} onBlur={this.handleAccountBlur} onFocus={this.handleAccountFocus} tabIndex="3" maxLength="18" />
                    </label>
                    <div id="accounttype" className="nopadbuttons text-center">
                        <h3>What type of account is it?</h3>
                        <div className="button-group">
                          <a className="btn yesno typebtn" data-answer="Savings" onClick={this.handleAccountTypeChange} tabIndex="4">Savings</a>
                          <a className="btn yesno typebtn" data-answer="Checking" onClick={this.handleAccountTypeChange}  onFocus={this.handleAccountTypeFocus} tabIndex="5">Checking</a>
                        </div>
                    </div>
                </div>
              </div>

              <NextFinanceButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.props.allbankingchecked} hideNext={!this.props.bankchecked} financestep={nextFinance} id="bankingchecked" tabIndex="6"/>

            </form>
          </div>
        </AccountLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    routingnum: state.FormReducer.routingnum,
    bank: state.FormReducer.bank,
    accounttype: state.FormReducer.accounttype,
    bankaccount: state.FormReducer.bankaccount,
    bankchecked: state.FormReducer.bankchecked,
    allbankingchecked: state.FormReducer.allbankingchecked,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step)),
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setFinance: (financestep) => dispatch(setFinance(financestep)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep))
});

export default connect(mapStateToProps, mapDispatchToProps)(BankingInfo)



// WEBPACK FOOTER //
// ./src/components/views/BankingInfo/index.js